var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseInput',{attrs:{"value":_vm.value,"type":"number"},on:{"input":modelValue => _vm.$emit('input', modelValue)}})
}
var staticRenderFns = []

export { render, staticRenderFns }